import { render, staticRenderFns } from "./AgentDashBoard.vue?vue&type=template&id=6faa8b17&"
import script from "./AgentDashBoard.vue?vue&type=script&lang=js&"
export * from "./AgentDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports